import {
  FundSummaryWidget,
  ThemeType,
  WidgetError,
  WidgetHeightMessage,
  WidgetMessage,
  WidgetNameSource,
} from "@labci/bell-fg-widgets";
import { Spin } from "antd";
import CircularProgress from "../Components/CircularProgress/CircularProgress";
import React, { useState } from "react";

export default function FundSummary() {
  const [isLoading, setIsLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token") || "";
  const symbol = queryParams.get("symbol") || "";
  const theme = queryParams.get("theme") || ThemeType.Direct;

  const handleNoData = (message: WidgetMessage) => {
    console.log("handleNoData", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleError = (error: WidgetError) => {
    console.log("handleError", error);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(error),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(error), "*");
  };

  const handleLoadingChange = (loading: boolean) => {
    setIsLoading(loading);

    const loadingMessage = {
      type: "loading",
      value: loading,
      source: WidgetNameSource.FundSummary,
    };
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(loadingMessage),
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(loadingMessage), "*");
  };

  const handleHeightChange = (message: WidgetHeightMessage) => {
    console.log("handleHeightChange", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(message),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleCallback = (message: WidgetMessage) => {
    console.log("handleCallback", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(message),
        "*",
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  return (
    <Spin
      wrapperClassName="widget-spin"
      spinning={isLoading}
      indicator={<CircularProgress theme={theme as ThemeType} />}
    >
      <FundSummaryWidget
        symbol={symbol}
        token={token}
        theme={theme as ThemeType}
        onError={handleError}
        onNoData={handleNoData}
        onLoadingChange={handleLoadingChange}
        onHeightChange={handleHeightChange}
      />
    </Spin>
  );
}
